<div #svgContainer class="svg-container"></div>
